import {
  GET_KEYWORD_SUCCEED,
  GET_KEYWORD_FAIL,
  GET_KEYWORD_START,
  GET_EXPORT_KEYWORD_START,
  GET_EXPORT_KEYWORD_FAIL,
  GET_EXPORT_KEYWORD_SUCCEED,
} from '../actionTypes/keyword'

export const initialState = {
  keywords: [],
  keywordsToExport: [],
  isLoadingKeywords: false,
  isLoadingExportKeywords: false,
}

const keyword = (state = initialState, action) => {
  switch (action.type) {
    case GET_KEYWORD_START:
      return {
        ...state,
        isLoadingKeywords: true,
        keywords: [],
      }
    case GET_KEYWORD_SUCCEED:
      return {
        ...state,
        isLoadingKeywords: false,
        keywords: action.data,
      }
    case GET_KEYWORD_FAIL:
      return {
        ...state,
        isLoadingKeywords: false,
        keywords: [],
      }
    case GET_EXPORT_KEYWORD_START:
      return {
        ...state,
        isLoadingExportKeywords: true,
        keywordsToExport: [],
      }
    case GET_EXPORT_KEYWORD_SUCCEED:
      return {
        ...state,
        isLoadingExportKeywords: false,
        keywordsToExport: action.data,
      }
    case GET_EXPORT_KEYWORD_FAIL:
      return {
        ...state,
        isLoadingExportKeywords: false,
        keywordsToExport: [],
      }
    default:
      return state
  }
}

export default keyword
